import React, { createContext, useEffect, useState } from "react";
import "../process.scss";
import { Button } from "primereact/button";
import { TabView, TabPanel } from "primereact/tabview";
import { Skeleton } from "primereact/skeleton";
import { getName } from "country-list";
import ReactCountryFlag from "react-country-flag";
import StatusBadge from "./StatusBadge";
import Layout from "../../../Layout";
import useProcess from "../actions/useProcess";
import Timelines from "../../../components/Timeline";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import MilestonesDetailsSidebar from "./MilestonesDetailsSidebar";
import useDateTime from "~/hooks/useDateTime";
import { format } from "date-fns";
const ProcessContext = createContext();

const ProcessLayout = ({ children }) => {
  const { process, milestones, milestonesLoading, allservices, formatDate } =
    useProcess();
  const navigate = useNavigate();
  const location = useLocation();
  const tabs = [
    { name: "Internal Conversations", route: "internal-conversations" },
    { name: "Public Conversations", route: "public-conversation" },
    { name: "Milestones", route: "milestones" },
    { name: "Attachments", route: "attachments" },
    { name: "Users & Permissions", route: "users-permission" },
    { name: "History", route: "history" },
  ];
  const activeIndex = tabs.findIndex((tab) =>
    location.pathname.includes(tab.route),
  );
  const [selectedIndex, setSelectedIndex] = useState(
    activeIndex !== -1 ? activeIndex : 2,
  );
  const { id } = useParams();

  useEffect(() => {
    setSelectedIndex(activeIndex !== -1 ? activeIndex : 2);
  }, [location.pathname]);

  const getHeaderName = () => {
    return (
      <p className="title">
        {`${process?.entityData?.name} (`}
        <ReactCountryFlag
          countryCode={process?.entityData?.country || ""}
          svg
          className=""
        />
        {` ${getName(process?.entityData?.country || "")})`}
        {` | `}
        {`${process?.name} ${getDeadlineDate()}`}
      </p>
    );
  };

  const getDeadlineDate = () => {
    if (process?.due_date) {
      const deadline =
        new Date(process?.due_date).getFullYear() +
        new Date(process?.due_date).toLocaleDateString("default", {
          month: "2-digit",
        });
      return deadline;
    }
  };

  const headerTemplate = (options) => {
    return (
      <div
        className={`${options.route} header-template-container`}
        onClick={() => {
          options.onClick();
          navigate(`/process/${id}/${options?.route}`);
        }}
      >
        <p className={options?.selected ? "tab-selected" : "header-value-name"}>
          {options?.name}
        </p>
        {process && options?.selected && (
          <StatusBadge status={process?.statusData} />
        )}
      </div>
    );
  };

  const timelineMarkerTemplate = (item) => {
    return !milestonesLoading ? (
      <StatusBadge status={item?.statusData} />
    ) : (
      <Skeleton width="20px" height="20px" shape="circle" />
    );
  };
  const formatDateInEntity = (utcDate) => {
    return format(utcDate, "MMMM do, yyyy");
  };

  const timelineContentTemplate = (item) => {
    return (
      <div className="sidebar-timeline-content-template">
        <p className="sidebar-timeline-content-label">
          {item?.name}{" "}
          {item.numberof_flagged_tasks > 0 && (
            <i className="pi pi-flag-fill text-warning ml-2 flag-red-icon"></i>
          )}
        </p>
        <p className="sidebar-timeline-content-status">{`(${item?.statusData?.name})`}</p>
        <p className="sidebar-timeline-content-date">
          {formatDateInEntity(item?.due_date)}
        </p>
      </div>
    );
  };

  return (
    <ProcessContext.Provider value={{ process, milestones }}>
      <Layout
        crumbs={[
          { label: "My Entities", url: "/entities" },
          {
            label: (
              <div className="flex">
                {process?.entityData?.name ? (
                  <>
                    {process.entityData.name}
                    <ReactCountryFlag
                      countryCode={process.entityData.country || ""}
                      svg
                      className=""
                    />{" "}
                    {getName(process.entityData.country || "")}
                  </>
                ) : (
                  <Skeleton width="100px" height="20px" className="mr-1" />
                )}
              </div>
            ),
            id: "entity",
            url: `/entity/${process?.entity}/dashboard`,
          },
          {
            label: "Entity Calendar",
            id: "entity-calendar",
            url: `/entity/${process?.entity}/calendar`,
          },
          {
            label: process?.name || (
              <Skeleton width="100px" height="20px" className="mr-1" />
            ),
            id: "process-name",
          },
        ]}
        SideNavSection={() => {
          return (
            <div className="sidenav-process">
              <div className="process-sidebar-container">
                <div className="sidebar-milestones-container">
                  <div className="details">
                    <p className="sidebar-milestones-label">Details</p>
                    <MilestonesDetailsSidebar
                      process={process}
                      allservices={allservices}
                      isLoader={milestonesLoading}
                    />
                  </div>
                  <div className="milestones">
                    <p className="sidebar-milestones-label">Milestones</p>
                    <div className="sidebar-timeline-container">
                      {milestonesLoading ? (
                        <div className="sidebar-timeline-content-template">
                          <Skeleton
                            width="100px"
                            height="20px"
                            className="mr-1"
                          />
                          <Skeleton
                            width="70px"
                            height="10px"
                            className="mr-1"
                          />
                          <Skeleton
                            width="100px"
                            height="10px"
                            className="mr-1"
                          />
                        </div>
                      ) : (
                        <Timelines
                          events={milestones}
                          markerTemplate={timelineMarkerTemplate}
                          contentTemplate={timelineContentTemplate}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        }}
        hideScrollbar={true}
      >
        {children}
      </Layout>
    </ProcessContext.Provider>
  );
};

export default ProcessLayout;
